import { Grid } from '@material-ui/core';
import { PaymentPlan, PaymentPlanLineStatus } from '@nemuru-eng/js-api-client';

import { StatusTagType } from '../../../../../../config/types';
import { useScreen } from '../../../../../../hooks/useScreen';
import { StatusTag } from '../../../../../shared/components/StatusTag/StatusTag';
import { ReadOnlyDataRow } from '../../../../../shared/components/ReadOnlyDataRow';
import { Text } from '../../../../../shared/components/Text';

interface PaymentPlanDetailsProps {
  paymentPlan: PaymentPlan;
}

export const PaymentPlanDetails = ({ paymentPlan }: PaymentPlanDetailsProps) => {
  const { isMobile } = useScreen();

  const getPaymentPlanOverallStatus = () => {
    const newPaymentPlan = { ...paymentPlan };
    if (paymentPlan.lines.every((line) => line.status === PaymentPlanLineStatus.CANCELLED))
      return <StatusTag type={StatusTagType.DEFAULT} labelTextId={'CANCELLED'} />;
    if (
      newPaymentPlan.lines
        .filter((line) => line.status !== PaymentPlanLineStatus.CANCELLED)
        .some((line) => !line.paymentDate && Date.now() > line.dueDate.getTime())
    )
      return <StatusTag type={StatusTagType.ERROR} labelTextId={'OVERDUE'} />;
    if (
      newPaymentPlan.lines
        .filter((line) => line.status !== PaymentPlanLineStatus.CANCELLED)
        .every((line) => line.paymentDate !== null)
    )
      return <StatusTag type={StatusTagType.SUCCESS} labelTextId={'PAID'} />;
    return <StatusTag type={StatusTagType.INFO} labelTextId={'PENDING'} />;
  };

  const currentPaymentPlanOverallStatus = getPaymentPlanOverallStatus();

  return (
    <Grid container spacing={isMobile ? 0 : 4}>
      <Grid item xs={12} lg={6}>
        <ReadOnlyDataRow
          underlined
          labelTextId={'PAYMENT_PROVIDER'}
          value={<Text tId={paymentPlan.paymentProvider} />}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <ReadOnlyDataRow underlined labelTextId={'PAYMENT_PLAN_STATUS'} value={currentPaymentPlanOverallStatus} />
      </Grid>
    </Grid>
  );
};
